import { GPTGameNameType } from '../../../types';
import { GAME_ORIGIN } from '../../../config';

export const postOrientationChange =
  (gameFrame: HTMLIFrameElement, gameName: GPTGameNameType) => (isLandscape: boolean) => {
    const data = JSON.stringify({
      orientation: isLandscape ? 'landscape' : 'portrait'
    });

    gameFrame.contentWindow?.postMessage(
      {
        type: 'ORIENTATION_CHANGE',
        gameName,
        data
      },
      GAME_ORIGIN
    );
  };
